export default __webpack_public_path__ + "static/media/IMG_20220102_084756.b978c567.png";